import { render } from "./EventDetail.vue?vue&type=template&id=c47e0fd4"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"
script.render = render

export default script